import angular from 'angular';
import uiRouter from 'angular-ui-router';
import DashboardMainComponent from './main.component';

const dashboardMainModule = angular.module('tinaba.components.dashboard.main', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('dashboard.main', {
      url: '/main',
      template: '<dashboard-main></dashboard-main>'
    });
})

.component('dashboardMain', DashboardMainComponent);

export default dashboardMainModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/dashboard/main/main.js
 **/